import { render, staticRenderFns } from "./widget-app-settings-dialog.vue?vue&type=template&id=c0adced2&lang=pug&"
import script from "./widget-app-settings-dialog.vue?vue&type=script&lang=ts&"
export * from "./widget-app-settings-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports